import { useEffect } from 'react';

import { IS_HYBRID_CART_ACTIVE } from 'core/services';
import { actions as actionsCart } from 'core/use-cases/cart/actions';
import { actions as actionsOrder } from 'core/use-cases/order/slice';
import { selectors as userSelectors } from 'core/use-cases/user';
import { useQueryState } from 'core/use-cases/utilities';
import { useDispatch } from 'react-redux';
import { useGetFeatureFlag } from 'ui/hooks';

import { useOrderSelector, useOrderViewSelector } from '../selectors';

export function useOrder() {
  const dispatch = useDispatch();
  const { data, isError, isIdle, isLoading, isSuccess } = useQueryState(useOrderSelector);
  const {
    data: { resellerId },
  } = userSelectors.useUserSelector();
  const { value: isHybridCartActive, loading } = useGetFeatureFlag(
    IS_HYBRID_CART_ACTIVE,
    false,
    resellerId,
  );

  const view = useOrderViewSelector();

  useEffect(() => {
    if (loading) {
      return;
    }
    dispatch(actionsOrder.orderFetch.request());

    return () => {
      dispatch(actionsOrder.orderCleanUp());
      if (isHybridCartActive) {
        dispatch(actionsCart.lastCartFetch.request());
      } else {
        dispatch(actionsCart.cartFetch.request());
      }
    };
  }, [loading]);

  return {
    data,
    isError,
    isIdle,
    isLoading,
    isSuccess,
    view,
  };
}

export function useOrderDetails() {
  const { data, isError, isLoading } = useQueryState(useOrderSelector);

  return { data, isError, isLoading };
}
